import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Header, Segment } from 'semantic-ui-react';
import HeaderSmall from './HeaderSmall';
import FooterBlock from './FooterBlock';

const About = () => (
  <div>
    <Helmet defer={false}>
      <title>TribeVibe - About Us</title>
    </Helmet>
    <HeaderSmall />
    <Segment style={{ padding: '8em 0em' }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
              About the Team
            </Header>
            <p style={{ fontSize: '1.2em' }}>
              We&apos;re a small team with a backgrounds in AI and machine
              learning, design and user experience. We have domain expertise in
              search, media and analytics.
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <FooterBlock />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js